import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import XLSX from 'xlsx'
import {Table, Button} from 'semantic-ui-react'

class StockTable extends Component {
    computeQty = (i) => {
        if (i.hasOwnProperty('qty_total_instock')) {
            let reserved = 0;
            let instock = 0;
            if (i.qty_total_instock) {
                instock = parseInt(i.qty_total_instock.instock)
            }
            if (i.qty_total_reserved) {
                reserved = Math.abs(parseInt(i.qty_total_reserved.quantity))
            }
            return {
                instock: instock,
                reserved: reserved,
                available: instock - reserved
            }
        }

        if (i.hasOwnProperty('qty_warehouse_instock')) {
            let reserved = 0;
            let instock = 0;
            if (i.qty_warehouse_instock.length > 0) {
                instock = parseInt(i.qty_warehouse_instock[0].instock)
            }
            if (i.qty_warehouse_reserved.length > 0) {
                reserved = Math.abs(parseInt(i.qty_warehouse_reserved[0].quantity))
            }
            return {
                instock: instock,
                reserved: reserved,
                available: instock - reserved
            }
        }

        return {
            instock: 0,
            reserved: 0,
            available: 0
        }
    }

    dataToExcel = () => {
        const fn = 'inventory.xlsx';
        let elt = document.getElementById('dls-data-table');
        let wb = XLSX.utils.table_to_book(elt, {sheet: "Inventory"});
        return XLSX.writeFile(wb, fn);
    }

    render() {
        return (
            <div className="row" style={{maxHeight: '575px', overflowY: 'scroll', height: '575px'}}>
                <div className="col-md-12" style={{marginBottom: '3px'}}>
                    <div style={{float:'right'}}>
                        <Button color='purple' size='mini' onClick={() => {this.dataToExcel()}}>Excel</Button>
                    </div>
                </div>
                <div className="col-md-12">
                <Table compact celled id='dls-data-table'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>SKU</Table.HeaderCell>
                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>UPC</Table.HeaderCell>
                            <Table.HeaderCell>Cost</Table.HeaderCell>
                            <Table.HeaderCell>Selling</Table.HeaderCell>
                            <Table.HeaderCell>Woo Ready</Table.HeaderCell>
                            <Table.HeaderCell>QB Ready</Table.HeaderCell>
                            <Table.HeaderCell>Reserved</Table.HeaderCell>
                            <Table.HeaderCell>In Stock</Table.HeaderCell>
                            <Table.HeaderCell>Available</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.data.map(i => {
                            const qty = this.computeQty(i);
                            return (
                                <Table.Row key={i.id}>
                                    <Table.Cell>{i.sku}</Table.Cell>
                                    <Table.Cell>{i.name}</Table.Cell>
                                    <Table.Cell>{i.upc}</Table.Cell>
                                    <Table.Cell>{i.cost}</Table.Cell>
                                    <Table.Cell>{i.selling}</Table.Cell>
                                    <Table.Cell>
                                        {i.woo_id ? "Yes" : ""}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {i.acct_id ? "Yes" : ""}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {qty.reserved}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {qty.instock}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {qty.available}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
                </div>
            </div>
        )
    }
}

StockTable.propTypes = {
    data: PropTypes.array.isRequired
};

export default StockTable


// WEBPACK FOOTER //
// ./src/components/reports/components/stock.js